export default (fieldsData, phoneField) => {
  const phone = String(fieldsData[phoneField]);
  const ext = String(fieldsData[`${phoneField}_ext`] || "");
  return `${phone.replace(/[^\d]/g, "")}${ext ? `;${ext}` : ""}`;
};
